import React, { useEffect, useState } from "react";
import loadConfig from "../../Services/apiService";
import { useDispatch, useSelector } from "react-redux";
import {
  GetLisExpectedObjectivesForStageByStageId,
  UpdateExpectedObjectivesForStageByStageId,
} from "../../Redux/Reducers/ReportStage/ExpectedObjectivesForStag";
import InputAHSF from "../../Components/InputAHSF";
import { ValidationAllPageReports } from "../../Redux/Reducers/ReportStage/ValidateReportStage";

function ExpectedObjectivesForStagea(props) {
  const [jsonData, setJsonData] = useState();
  const [expectedList, setexpectedList] = useState([]);
  const [Refresh, setRefresh] = useState(false);
  const [
    descriptionOfAchievementOfSubGoals,
    setDescriptionOfAchievementOfSubGoals,
  ] = useState("");
  const [achievementOfSubGoals, setAchievementOfSubGoals] = useState(0);
  const getJsonData = async () => {
    let jsonData = await loadConfig();
    setJsonData(jsonData);
  };
  const reportStageGuid=useSelector((state)=>state.Stages.reportStageGuid)

  useEffect(() => {
    getJsonData();
  }, []);

  const dispatch = useDispatch(); // Used to dispatch Redux actions.
  const state = useSelector((state) => {
    return {
      loadingLisExpectedObjectivesForStage:
        state.ExpectedObjectivesForStage.loadingLisExpectedObjectivesForStage,
      ValidateReportStage: state.ValidateReportStage.ValidateReportStage,
      ReportStatusByApplicationGuid:
        state.TransferItemInformation.ReportStatusByApplicationGuid,
    };
  });
  console.log(props.specificOrMulti, "props.specificOrMulti");

  const getData = async () => {
    let data = await dispatch(
      GetLisExpectedObjectivesForStageByStageId({
        specificOrMulti: props.specificOrMulti ? props.specificOrMulti : true,
        stageGuid: props.pR_ReportsStagesGuid,
        reportGuid: state.ReportStatusByApplicationGuid?.pR_ReportsId,
        applicationInfoGuid: "string",
      })
    );
    if (data?.payload.length) {
      setexpectedList(data?.payload);
    }
  };

  useEffect(() => {
    getData();
  }, [Refresh,reportStageGuid]);

  const UpdateExpected = async (column, description, achievement) => {
    setRefresh(false);

    const update = await dispatch(
      UpdateExpectedObjectivesForStageByStageId({
        pR_ExpectedObjectivesForStageId: column.pR_ExpectedObjectivesForStageId,
        pR_ObjectiveProjectsId: column.pR_ObjectiveProjectsId,
        pR_ReportsStagesGuid: column.pR_ReportsStagesGuid,
        subObjectives: column.subObjectives,
        percentageMainAndSubObjecive: column.percentageMainAndSubObjecive,
        descriptionOfAchievementOfSubGoals: descriptionOfAchievementOfSubGoals
          ? descriptionOfAchievementOfSubGoals
          : description,
        achievementOfSubGoals: achievementOfSubGoals
          ? achievementOfSubGoals
          : achievement,
        remainingCompletionGoal: column.remainingCompletionGoal,
        canEdit: column.canEdit,
        pR_ReportsId: column.pR_ReportsId,
      })
    );
    if (update.payload == "success") {
      setDescriptionOfAchievementOfSubGoals("");
      setAchievementOfSubGoals(0);
      setRefresh(true);
    }
  };


  return (
    <>
      <div id="EvaluationInformationId" className="ContinerMarks-section">
        <p className="title">{jsonData?.ExpectedObjectivesForStage?.nameAR}</p>
        <div className="ContinerTableYesNo">
          <table>
            <thead>
              <tr key="1">
                {/* {props.specificOrMulti == false ? (
                  <th>{jsonData?.ExStages?.nameAR}</th>
                ) : (
                  ""
                )} */}
                <th>{jsonData?.objectiveName?.nameAR}</th>
                <th>{jsonData?.SubObjectivesToBeAchieved?.nameAR}</th>
                <th>{jsonData?.SubMainGoal?.nameAR}</th>
                <th>{jsonData?.DescriptionAchievementSubGoals?.nameAR}</th>
                <th>{jsonData?.AchievementOfSubObjectives?.nameAR} </th>
                <th>{jsonData?.RemainingAchievemenOfTheMainGoal?.nameAR} </th>
              </tr>
            </thead>
            <tbody>
              {expectedList &&
                expectedList.map((elem, index) => {
                  return (
                    <>
                      <tr key={elem.pR_ExpectedObjectivesForStageId}>
                        {/* {props.specificOrMulti == false ? (
                          <td>
                            {elem.pR_ReportsStage?.pR_StagesNumber?.stagesName}
                          </td>
                        ) : (
                          ""
                        )} */}
                        <td>{elem.pR_ObjectiveProjects.objectiveName}</td>
                        <td>{elem.subObjectives} </td>
                        <td>{elem.percentageMainAndSubObjecive}</td>

                        <td>
                          <InputAHSF
                            fieldsName="yesNoTableDropDown"
                            show={true}
                            hidelable={true}
                            disabled={!props.canEdit}
                            className="form_control_input"
                            defaultValue={
                              elem.descriptionOfAchievementOfSubGoals
                            }
                            style={{ width: "100%" }}
                            onChange={async (e) => {
                              await setDescriptionOfAchievementOfSubGoals(
                                e.target.value
                              );
                            }}
                            onBlur={async (e) => {
                              await UpdateExpected(
                                elem,
                                e.target.value,
                                elem.achievementOfSubGoals
                              );
                            }}
                            showValidationMessage={
                              state.ValidateReportStage
                                ? state.ValidateReportStage.includes(
                                    `DescriptionOfAchievementOfSubGoals` +
                                      elem.pR_ExpectedObjectivesForStageId
                                  )
                                : false
                            }
                            validationMessage="حقل اجباري"
                          />
                        </td>

                        <td>
                          <InputAHSF
                            fieldsName="yesNoTableDropDown"
                            show={true}
                            hidelable={true}
                            style={{ width: "100%" }}
                            className={`form_control_input `}
                            type="number"
                            disabled={!props.canEdit}
                            defaultValue={elem.achievementOfSubGoals}
                            onChange={async (e) => {
                              await setAchievementOfSubGoals(e.target.value);
                            }}
                            onBlur={async (e) => {
                              await UpdateExpected(
                                elem,
                                elem.descriptionOfAchievementOfSubGoals,
                                e.target.value
                              );
                            }}
                            showValidationMessage={
                              state.ValidateReportStage
                                ? state.ValidateReportStage.includes(
                                    `AchievementOfSubGoals` +
                                      elem.pR_ExpectedObjectivesForStageId
                                  )
                                : false
                            }
                            validationMessage="حقل اجباري"
                          />
                        </td>
                        <td>{elem.remainingCompletionGoal}</td>
                      </tr>
                    </>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ExpectedObjectivesForStagea;
